import { StationNotFoundPage } from '@app/components/stations/StationNotFoundPage';
import { StationCtxProvider } from '@app/core/containers/StationCtx';
import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { PropsWithChildren } from 'react';
import { useParams } from 'react-router';

/**
 * Resolves a station by slug from the current route params and provides it via context.
 * Reads slug from useParams (supports both "slug" and "station" param names for route compatibility).
 * Renders StationNotFoundPage when the station does not exist; otherwise wraps children
 * in StationCtxProvider.
 */
export function StationPageWrapper({ children }: PropsWithChildren) {
  const { slug, station } = useParams<{ slug?: string; station?: string }>();
  const resolvedSlug = slug ?? station;
  const finder = useStationsFinder();
  const stationEntity = finder(resolvedSlug ?? '');

  if (!stationEntity) {
    return <StationNotFoundPage />;
  }

  return <StationCtxProvider station={stationEntity}>{children}</StationCtxProvider>;
}
